
import { Card, CardContent } from "@/components/ui/card";
import { Mail, CheckCircle, XCircle, Eye } from "lucide-react";

interface NotificationSummaryCardsProps {
  summary: {
    totalSent: number;
    deliveryRate: number;
    readRate: number;
    failureRate: number;
  };
}

const NotificationSummaryCards = ({ summary }: NotificationSummaryCardsProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Total Sent</p>
              <p className="text-2xl font-bold text-foreground">{summary.totalSent.toLocaleString()}</p>
            </div>
            <Mail className="h-8 w-8 text-blue-500" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Delivery Rate</p>
              <p className="text-2xl font-bold text-foreground">{summary.deliveryRate.toFixed(1)}%</p>
            </div>
            <CheckCircle className="h-8 w-8 text-green-500" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Read Rate</p>
              <p className="text-2xl font-bold text-foreground">{summary.readRate.toFixed(1)}%</p>
            </div>
            <Eye className="h-8 w-8 text-purple-500" />
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-muted-foreground">Failure Rate</p>
              <p className="text-2xl font-bold text-foreground">{summary.failureRate.toFixed(1)}%</p>
            </div>
            <XCircle className="h-8 w-8 text-red-500" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotificationSummaryCards;
